var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.facet.name
    ? _c("div", { staticClass: "p-3 bg-white border-bottom" }, [
        _c("div", { staticClass: "h3" }, [_vm._v(_vm._s(_vm.facetName))]),
        _vm._v(" "),
        _vm.facet.type === "price"
          ? _c("div", [_c("item-filter-price")], 1)
          : _vm.facet.cssClass === "has-pictures"
          ? _c(
              "div",
              { staticClass: "row row-cols-3 row-cols-md-2 text-center mx-n2" },
              _vm._l(_vm.facets, function(value) {
                return _c(
                  "div",
                  { key: value.id, staticClass: "col my-1 px-2" },
                  [
                    _c("input", {
                      staticClass: "form-check-input d-none",
                      attrs: {
                        id: "option-" + value.id + "-" + _vm._uid,
                        type: "checkbox",
                        disabled: _vm.isLoading || value.count <= 0
                      },
                      domProps: { checked: _vm.isSelected(value.id) },
                      on: {
                        change: function($event) {
                          return _vm.updateFacet(value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label border rounded-lg px-2",
                        class: [
                          _vm.paddingClasses,
                          _vm.isSelected(value.id) ? "bg-appearance" : "",
                          "option-" + value.id
                        ],
                        style: _vm.paddingInlineStyles,
                        attrs: { for: "option-" + value.id + "-" + _vm._uid }
                      },
                      [
                        _c(
                          "figure",
                          { staticClass: "figure m-0" },
                          [
                            _c("lazy-img", {
                              attrs: {
                                "image-url":
                                  "https://cdn03.plentymarkets.com/qa2p27o67u8f/frontend/facetten/" +
                                  _vm.facet.id +
                                  "/" +
                                  value.id +
                                  ".png",
                                "picture-class": "img-fluid",
                                title: value.name,
                                "data-alt": value.name
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "figcaption",
                              {
                                staticClass: "figure-caption text-center mt-2"
                              },
                              [_vm._v(_vm._s(value.name))]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            )
          : _c(
              "div",
              { staticClass: "row row-cols-3 row-cols-md-2 text-center mx-n2" },
              _vm._l(_vm.facets, function(value) {
                return _c(
                  "div",
                  { key: value.id, staticClass: "col my-1 px-2" },
                  [
                    _c("input", {
                      staticClass: "form-check-input d-none",
                      attrs: {
                        id: "option-" + value.id + "-" + _vm._uid,
                        type: "checkbox",
                        disabled: _vm.isLoading || value.count <= 0
                      },
                      domProps: { checked: _vm.isSelected(value.id) },
                      on: {
                        change: function($event) {
                          return _vm.updateFacet(value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label border rounded-lg px-2",
                        class: [
                          _vm.paddingClasses,
                          _vm.isSelected(value.id) ? "bg-appearance" : "",
                          "option-" + value.id
                        ],
                        style: _vm.paddingInlineStyles,
                        attrs: { for: "option-" + value.id + "-" + _vm._uid }
                      },
                      [
                        _c("div", { staticClass: "d-flex" }, [
                          _c("span", { staticClass: "flex-grow-1" }, [
                            _vm._v(_vm._s(value.name))
                          ])
                        ])
                      ]
                    )
                  ]
                )
              }),
              0
            )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }